import { hosts } from 'settings';

export const SignupFormPersonal = {
  bindings: {
    isDisabled: '<',
    isLoading: '<',
    chargifyData: '<',
    product: '<',
    text: '<',
    member: '<',
    onSubmit: '&',
    onUpdate: '&',
  },

  template: `
    <form class="voome-form"
      name="form"
      ng-submit="$ctrl.onSubmit()"
      novalidate>
      <fieldset class="mb-5"
        ng-class="{ 'disabled': $ctrl.isDisabled }">
        <strong>Personal Details</strong>
        <hr class="mt-1">
        <div class="mb-3">
          <form-group-row>
            <form-group-left>
              <form-label for="couponCode">
                Coupon Code
              </form-label>
            </form-group-left>
            <form-group-right>
              <input class="form-control"
                ng-class="{
                  'is-valid': !$ctrl.isDisabled && form.couponCode.$touched && form.couponCode.$valid,
                  'is-invalid': form.couponCode.$touched && form.couponCode.$invalid,
                }"
                id="couponCode"
                name="couponCode"
                type="text"
                required
                ng-blur="couponCodeFunction.validate()"
                ng-init="couponCode = $ctrl.chargifyData.couponCode"
                ng-model="couponCode"
                ng-disabled ="$ctrl.isDisabled"
                ng-change="$ctrl.onUpdate({
                  key: 'couponCode',
                  value: form.couponCode.$viewValue
                })"
                coupon-validation>
              <i class="spinner" loading-spinner="!couponCodeFunction.loading" data-auto-hide></i>
              <form-errors
                field="form.couponCode"
                errors="{ required: 'This is a required field.',
                          couponValidation: 'This coupon is invalid.' }">
              </form-errors>
            </form-group-right>
          </form-group-row>
          <form-group-row>
            <form-group-left>
              <form-label for="email">
                Email
              </form-label>
            </form-group-left>
            <form-group-right>
              <input class="form-control"
                ng-class="{
                  'is-valid': !$ctrl.isDisabled && form.email.$touched && form.email.$valid,
                  'is-invalid': form.email.$touched && form.email.$invalid,
                  'opacity-5': !(form.couponCode.$touched && form.couponCode.$valid) || emailExists,
                }"
                id="email"
                name="email"
                type="email"
                required
                ng-init="email = $ctrl.chargifyData.email"
                ng-model="email"
                ng-disabled ="$ctrl.isDisabled || !(form.couponCode.$touched && form.couponCode.$valid) || emailExists"
                ng-change="$ctrl.onUpdate({
                  key: 'email',
                  value: form.email.$viewValue
                })">
              <form-errors
                field="form.email"
                errors="{
                  required: 'This is a required field.',
                  email: 'Must be a valid email address.',
                }">
              </form-errors>
              <div
                class="help-text pl-2 pt-2"
                ng-if="$ctrl.text.discountText"
                ng-bind-html="$ctrl.text.discountText">
              </div>
            </form-group-right>
          </form-group-row>
          <form-group-row>
            <form-group-left>
              <form-label for="emailConfirmation">
                Email Confirmation
              </form-label>
            </form-group-left>
            <form-group-right>
              <input class="form-control"
                ng-class="{
                  'is-valid': !$ctrl.isDisabled && form.emailConfirmation.$touched && form.emailConfirmation.$valid,
                  'is-invalid': form.emailConfirmation.$touched && form.emailConfirmation.$invalid,
                  'opacity-5': !(form.couponCode.$touched && form.couponCode.$valid) || emailExists,
                }"
                id="emailConfirmation"
                name="emailConfirmation"
                type="email"
                match="form.email"
                required
                ng-init="emailConfirmation = $ctrl.chargifyData.emailConfirmation"
                ng-model="emailConfirmation"
                ng-disabled ="$ctrl.isDisabled || !(form.couponCode.$touched && form.couponCode.$valid) || emailExists"
                ng-change="$ctrl.onUpdate({
                  key: 'emailConfirmation',
                  value: form.emailConfirmation.$viewValue
                })">
              <form-errors
                field="form.emailConfirmation"
                errors="{
                  required: 'This is a required field.',
                  email: 'Must be a valid email address.',
                  match: 'Email & confirmation must match.',
                }">
              </form-errors>
            </form-group-right>
          </form-group-row>
          <form-group-row>
            <form-group-left>
              <form-label for="firstName">
                First Name
              </form-label>
            </form-group-left>
            <form-group-right>
              <input class="form-control"
                ng-class="{
                  'is-valid': !$ctrl.isDisabled && form.firstName.$touched && form.firstName.$valid,
                  'is-invalid': form.firstName.$touched && form.firstName.$invalid,
                  'opacity-5': !(form.couponCode.$touched && form.couponCode.$valid),
                }"
                id="firstName"
                name="firstName"
                type="text"
                required
                ng-init="firstName = $ctrl.chargifyData.firstName"
                ng-model="firstName"
                ng-disabled ="$ctrl.isDisabled || !(form.couponCode.$touched && form.couponCode.$valid)"
                ng-change="$ctrl.onUpdate({
                  key: 'firstName',
                  value: form.firstName.$viewValue
                })">
              <form-errors
                field="form.firstName"
                errors="{ required: 'This is a required field.' }">
              </form-errors>
            </form-group-right>
          </form-group-row>
          <form-group-row>
            <form-group-left>
              <form-label for="lastName">
                Last Name
              </form-label>
            </form-group-left>
            <form-group-right>
              <input class="form-control"
                ng-class="{
                  'is-valid': !$ctrl.isDisabled && form.lastName.$touched && form.lastName.$valid,
                  'is-invalid': form.lastName.$touched && form.lastName.$invalid,
                  'opacity-5': !(form.couponCode.$touched && form.couponCode.$valid),
                }"
                id="lastName"
                name="lastName"
                type="text"
                required
                ng-init="lastName = $ctrl.chargifyData.lastName"
                ng-model="lastName"
                ng-disabled ="$ctrl.isDisabled || !(form.couponCode.$touched && form.couponCode.$valid)"
                ng-change="$ctrl.onUpdate({
                  key: 'lastName',
                  value: form.lastName.$viewValue
                })">
              <form-errors
                field="form.lastName"
                errors="{ required: 'This is a required field.' }">
              </form-errors>
            </form-group-right>
          </form-group-row>
        </div>
        <div class="row justify-content-end">
          <div class="col-md-12 text-center">
            <button class="btn btn-lg btn-pill theme-btn"
              type="submit"
              ng-hide="$ctrl.isDisabled"
              ng-disabled="$ctrl.isDisabled || form.$invalid">
              <spinner is-loading="$ctrl.isLoading && form.$valid">
                Submit
              </spinner>
            </button>
          </div>
        </div>
        <hr>
        <div class="form-group form-row justify-content-center">
            <a class="small font-size-sm-base"
              ui-sref="login">Already have an account? Sign in!</a>
        </div>
      </fieldset>
    </form>`,

  controller($scope, $timeout, $http, $stateParams) {
    'ngInject';

    ($scope.emailExists = false),
      ($scope.programs = []),
      ($scope.couponCodeFunction = {
        loading: false,
        validate: function() {
          var couponCodeValue = $scope.form.couponCode.$viewValue;
          if (couponCodeValue) {
            $scope.couponCodeFunction.loading = true;
            var value = $scope.form.couponCode.$viewValue,
              valid = false;
            // CouponCode.validate_code({ code: couponCodeValue }, $scope.couponCodeFunction.success);
            $http
              .get(
                `${
                  hosts.api
                }/v3/coaching_zone/coupon-code?coupon=${couponCodeValue}`
              )
              .then(
                function successCallback(response) {
                  if (response.status == 200 && response.data.coupon) {
                    valid = true;
                    $scope.programs = response.data;
                    $scope.form.couponCode.$setValidity(
                      'couponValidation',
                      true
                    );
                  } else {
                    $scope.form.couponCode.$setValidity(
                      'couponValidation',
                      false
                    );
                  }
                },
                function errorCallback(response) {
                  $scope.form.couponCode.$setValidity(
                    'couponValidation',
                    false
                  );
                }
              );
          }
        },
      });

    return {
      $onInit() {
        if ($stateParams.email) {
          setTimeout(() => {
            $scope.emailExists = true;
            const email = $stateParams.email;
            $scope.form['emailConfirmation'].$setViewValue(email);
            $scope.form['email'].$setViewValue(email);
            $scope.form['emailConfirmation'].$render();
            $scope.form['email'].$render();
          });
        }
      },
      $onChanges() {
        if (
          this.member &&
          this.member.email &&
          $scope.form &&
          !$scope.form.email.$modelValue
        ) {
          ['email', 'firstName', 'lastName'].map(key => {
            $scope.form[key].$setViewValue(this.member[key]);
            $scope.form[key].$render();
          });

          $scope.form['emailConfirmation'].$setViewValue(this.member['email']);
          $scope.form['emailConfirmation'].$render();
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupFormPersonal.js